import { render, staticRenderFns } from "./GoogleSigninButton.vue?vue&type=template&id=62627144&"
import script from "./GoogleSigninButton.vue?vue&type=script&lang=js&"
export * from "./GoogleSigninButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports